import { Colors, Text, View } from 'react-native-ui-lib';
import { navigationProps } from '../typings/types';
import { FlatList } from 'react-native';
import React, { useEffect } from 'react';
import { useIsMobile } from '../MediaQueries';
import { strings } from '../localization/localization.web';
import { useCourses } from '../firebaseWrapper/firebaseWrapper';
import { NothingHereInformation } from './Alert';
import { CourseItem } from './general/ListItems';
import { PremiumFeatureDialog } from './Dialogs';

export function CoursesScreen({
  navigation,
  route,
}: navigationProps): JSX.Element {
  const isMobile = useIsMobile();
  const [courses, coursesLoading] = useCourses();

  useEffect(() =>
    console.log("Courses", courses),
    [courses]
  )

  const navigateToCourse = (courseId: string) => {
    navigation.push("course", { id: courseId });
  }

  return (
    <View
      flex
      style={{
        backgroundColor: Colors.primaryBG
      }}
    >
      <View flex
        style={{
          backgroundColor: isMobile ? 'transparent' : Colors.secondaryBG,
          borderRadius: 20,
          marginHorizontal: isMobile ? 0 : 5,
          marginVertical: 5,
          overflow: 'hidden',
          padding: 20
        }}
      >
        <Text h1 marginB-10 style={{ color: Colors.textPrimary }}>
          {strings.learn}
        </Text>
        <FlatList
          data={courses}
          showsVerticalScrollIndicator={false}
          numColumns={1}
          renderItem={({ item }) => (
            <CourseItem
              testID={`course-item-${item.id}`}
              title={item.title}
              description={item.description}
              handlePress={item.premium ? () => PremiumFeatureDialog("Mehr Kurse", strings) : () => navigateToCourse(item.id)}
              premium={item.premium}
            />
          )}
          keyExtractor={item => item.id}
          ItemSeparatorComponent={() => <View style={{ height: 10 }} />}
          ListEmptyComponent={() => <NothingHereInformation text={strings.no_groups_info} />}
        />
      </View>
    </View>
  );
}